import { useEffect, useLayoutEffect, useRef } from "react";


const useKeyWithShift = (key, callBack) => {
    // KEY IS ALPHABET ALWAYS IN lowercase
    const callbackRef = useRef(callBack);

    useLayoutEffect(() => {
        callbackRef.current = callBack;
    });

    useEffect(() => {

        function handle(event) {
            if (event.shiftKey && event?.key?.toLowerCase() === key) {
                event.preventDefault();
                event.stopPropagation();
                callBack(event);
            }
            else { }
        }
        window.addEventListener("keyup", handle);
        return () => window.removeEventListener("keyup", handle);

    }, [callBack, key]);
};

export default useKeyWithShift;